<template>
  <div class="row">
    <div class="col-md-8">
      <div class="card card-custom gutter-b">
        <div class="card-header card-header-tabs-line">
          <div class="card-title">
            <h1 class="card-label">{{ $t('REISETERMINE.RELEASEPROZESS.TITLE') }}</h1>
          </div>
          <div class="card-toolbar d-flex text-align-center">
            <SavedContent :isSaved="isSaved"></SavedContent>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-12 d-flex align-items-center">
              <div v-if="processObj" class="flex-fill mb-0">
                <b-form-group
                  :disabled="reiseterminObj?.state !== 'Aufgelegt' || !isReiseterminInReleasePruefung"
                  class="mb-0"
                >
                  <h6>{{ $t('REISETERMINE.RELEASEPROZESS.STEP1TITLE') }}</h6>
                  <p>
                    {{ $t('REISETERMINE.RELEASEPROZESS.STEP1TEXT1') }}
                  </p>
                  <div class="row">
                    <div class="col-md-2">Hotels</div>
                    <b-form-radio-group v-model="processObj.dmcHotels" @input="onChange" class="col-md-10">
                      <b-form-radio :value="true">Ja</b-form-radio>
                      <b-form-radio :value="false">Nein</b-form-radio>
                    </b-form-radio-group>

                    <div class="col-md-2">Programm</div>
                    <b-form-radio-group v-model="processObj.dmcProgramm" @input="onChange" class="col-md-10">
                      <b-form-radio :value="true">Ja</b-form-radio>
                      <b-form-radio :value="false">Nein</b-form-radio>
                    </b-form-radio-group>
                    <div class="col-md-2">Fahrzeug</div>
                    <b-form-radio-group v-model="processObj.dmcFahrzeug" @input="onChange" class="col-md-10">
                      <b-form-radio :value="true">Ja</b-form-radio>
                      <b-form-radio :value="false">Nein</b-form-radio>
                    </b-form-radio-group>
                  </div>
                </b-form-group>

                <b-form-group :disabled="isReleasepruefungAufTerminebeneDisabled" class="mb-0">
                  <p class="mt-4 mb-4">
                    Es wurden Änderungen vom SKR Country Manager bei folgenden Leistungen angefragt:
                  </p>
                  <div class="row">
                    <div class="col-md-2 d-flex align-items-center">Hotelwechsel</div>
                    <div class="col-md-10 d-flex align-items-center">
                      <b-form-radio-group v-model="processObj.dmcHotelwechsel" @input="onChange" class="mr-4">
                        <b-form-radio :value="'Ja'">Ja</b-form-radio>
                        <b-form-radio :value="'JaMitNachreichung'">Ja mit Nachreichung</b-form-radio>
                        <b-form-radio :value="'Nein'">Nein</b-form-radio>
                      </b-form-radio-group>
                      <div class="d-flex align-items-center">
                        <div class="mr-2">Anzahl der Hotelwechsel:</div>
                        <AppSelect
                          v-model="processObj.dmcAnzahlHotelwechsel"
                          :options="hotelwechselSelectOptions"
                          :disabled="isReleasepruefungAufTerminebeneDisabled"
                          label="Anzahl der Hotelwechsel"
                          placeholder="---"
                          hide-search
                          class="hotelwechsel-select"
                          @input="onChange"
                          size="sm"
                        />
                      </div>
                    </div>

                    <div class="col-md-2 d-flex align-items-center">Hotelwechsel nach Grid Bearbeitung</div>
                    <div class="col-md-10 d-flex align-items-center">
                      <b-form-radio-group
                        v-model="processObj.dmcHotelwechselGrid"
                        @input="onChange"
                        class="mr-4"
                      >
                        <b-form-radio :value="'Ja'">Ja</b-form-radio>
                        <b-form-radio :value="'JaMitNachreichung'">Ja mit Nachreichung</b-form-radio>
                        <b-form-radio :value="'Nein'">Nein</b-form-radio>
                      </b-form-radio-group>
                      <div class="d-flex align-items-center">
                        <div class="mr-2">Anzahl der Hotelwechsel:</div>
                        <AppSelect
                          v-model="processObj.dmcAnzahlHotelwechselGrid"
                          :options="hotelwechselSelectOptions"
                          :disabled="isReleasepruefungAufTerminebeneDisabled"
                          label="Anzahl der Hotelwechsel"
                          placeholder="---"
                          hide-search
                          class="hotelwechsel-select"
                          @input="onChange"
                          size="sm"
                        />
                      </div>
                    </div>

                    <div class="col-md-2">Reiseleiterwechsel</div>
                    <b-form-radio-group
                      v-model="processObj.dmcReiseleiterwechsel"
                      @input="onChange"
                      class="col-md-10"
                    >
                      <b-form-radio :value="'Ja'">Ja</b-form-radio>
                      <b-form-radio :value="'JaMitNachreichung'">Ja mit Nachreichung</b-form-radio>
                      <b-form-radio :value="'Nein'">Nein</b-form-radio>
                    </b-form-radio-group>
                    <div class="col-md-2">Programmwechsel</div>
                    <b-form-radio-group
                      v-model="processObj.dmcProgrammwechsel"
                      @input="onChange"
                      class="col-md-10"
                    >
                      <b-form-radio :value="'Ja'">Ja</b-form-radio>
                      <b-form-radio :value="'JaMitNachreichung'">Ja mit Nachreichung</b-form-radio>
                      <b-form-radio :value="'Nein'">Nein</b-form-radio>
                    </b-form-radio-group>
                  </div>
                </b-form-group>
              </div>
              <template v-else>
                <b-skeleton width="100%" height="50px"></b-skeleton>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="card card-custom">
        <div class="card-header card-header-tabs-line">
          <div class="card-title">
            <h1 class="card-label">{{ $t('REISETERMINE.RELEASEPROZESS.TRANSFERPLANUNG.TITLE') }}</h1>
          </div>
          <div class="card-toolbar d-flex text-align-center">
            <SavedContent :isSaved="isTransferplanungSaved"></SavedContent>
          </div>
        </div>
        <div class="card-body">
          <b-form-group
            v-if="processObj"
            :disabled="reiseterminObj?.state !== 'Aufgelegt' || !isReiseterminInReleasePruefung"
            class="flex-fill mb-0"
          >
            <p>
              {{ $t('REISETERMINE.RELEASEPROZESS.TRANSFERPLANUNG.TEXT1') }}
            </p>
            <b-form-checkbox v-model="processObj.transferplanungGeprueft" @input="onChange">
              <div
                class="border rounded px-1"
                v-b-tooltip.hover
                title="Nur im 3. Part der Transferplanung setzbar."
              >
                {{ $t('REISETERMINE.RELEASEPROZESS.TRANSFERPLANUNG.DONE') }}
                <span class="text-danger font-size-h5" v-b-tooltip.hover title="Pflichtfeld">*</span>
              </div>
            </b-form-checkbox>
          </b-form-group>
          <template v-else-if="!isLoading">
            <div class="p-5 bg-secondary rounded w-100">
              {{ $t('REISETERMINE.RELEASEPROZESS.TRANSFERPLANUNG.NODATA') }}
            </div>
          </template>
          <template v-else>
            <b-skeleton width="100%" height="50px"></b-skeleton>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiService from '@/core/common/services/api.service';
import * as odataService from '@/core/common/services/odata.service';
import SavedContent from '@/components/common/saved-content.vue';
import { hotelwechselOptions } from '@/core/common/helpers/utils.js';
import AppSelect from '@/components/common/app-select/app-select.vue';
export default {
  name: 'ReiseterminCardReleaseProcess',
  components: {
    SavedContent,
    AppSelect,
  },
  props: {
    reiseterminkuerzel: String,
    reiseterminId: Number,
    isReiseterminInReleasePruefung: { type: Boolean, default: false },
    isInTransferplanung: { type: Boolean, default: false },
    reiseterminObj: { type: Object },
  },
  data() {
    return {
      isLoading: true,
      isSaved: true,
      isTransferplanungSaved: true,
      formInputDebounceValue: 300,
      debounceTimeoutId: null,
      processObj: null,
      hotelwechselOptions,
    };
  },
  async mounted() {
    this.isLoading = true;
    const processes = await this.getCurrentProcess();
    this.processObj = processes;
  },
  computed: {
    // Die Anzahlen sind Zahlen, als Optionstext werden sie in Strings gewandelt
    hotelwechselSelectOptions() {
      return this.hotelwechselOptions.map(anzahl => ({ value: anzahl, text: String(anzahl) }));
    },
    isReleasepruefungAufTerminebeneDisabled() {
      const state = this.reiseterminObj?.state;
      const stateAllowed = ['Aufgelegt', 'Durchfuehrung', 'Durchgefuehrt'].includes(state);
      return !stateAllowed || !this.isReiseterminInReleasePruefung;
    },
  },
  methods: {
    saveProcess() {
      console.log(this.processObj);
      apiService
        .put('Reisetermin/' + this.reiseterminId + '/releaseprozess', {
          id: this.reiseterminId,
          ...this.processObj,
        })
        .then(() => {
          this.toast(this.$t('WORKFLOWS.COMMON.SAVED'));
          this.$emit('releaseprocess-updated');
        })
        .catch(err => {
          console.error(err);
        })
        .finally(() => {
          this.isSaved = true;
          this.isLoading = false;
        });
    },
    onChange() {
      this.isSaved = false;
      this.isLoading = true;
      this.saveProcess();
    },
    async getCurrentProcess() {
      const filter = { id: this.reiseterminId };

      return odataService
        .getReisetermin({
          filter,
          expand: {
            hotelleistungen: {
              expand: {
                vorgang: {},
              },
            },
            Reise: {},
            Metadata: {
              expand: {
                ZiellandZielflughaefen: {},
                ZiellandAbflughaefen: {},
                Inlandsfluege: {},
              },
            },
            gueltigeKonfiguration: {},
            pax: {},
            comments: {},
          },
        })
        .then(response => {
          const {
            dmcHotels,
            dmcProgramm,
            dmcProgrammwechsel,
            reiseunterlagenGeprueft,
            transferplanungGeprueft,
            dmcFahrzeug,
            dmcHotelwechsel,
            dmcHotelwechselGrid,
            dmcReiseleiterwechsel,
            dmcAnzahlHotelwechsel,
            dmcAnzahlHotelwechselGrid,
          } = response.data[0];
          return {
            dmcHotels,
            dmcProgramm,
            dmcProgrammwechsel,
            dmcHotelwechsel,
            dmcHotelwechselGrid,
            dmcReiseleiterwechsel,
            dmcFahrzeug,
            reiseunterlagenGeprueft,
            transferplanungGeprueft,
            dmcAnzahlHotelwechsel,
            dmcAnzahlHotelwechselGrid,
          };
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style scoped>
.hotelwechsel-select {
  --app-select-padding-x: 6px;
  width: 72px;
}
</style>
